
import { Component, Prop, Vue } from 'vue-property-decorator';
import api from '@/api';
import moment from 'moment';
import { Route } from 'vue-router';
import Swal from 'sweetalert2';
import ItemForm from './Form.vue';

const { couponActivity } = api;

@Component({
  components: { ItemForm },
})
export default class CouponActivityEdit extends Vue {
  @Prop({}) private activityId!: string;

  private form = {
    activityType: null,
    title: null,
    couponProducts: [],
    wideImageUrl: null,
    narrowImageUrl: null,
    widePic: null,
    narrowPic: null,
    memo: null,
    startTime: null,
    endTime: null,
    invitationCode: null,
  };

  private loading: boolean = false;

  private isActivityStarted: boolean = false;

  private async submit(form: any) {
    if (form) {
      this.loading = true;
      const { status } = await couponActivity.update(this.activityId, form);
      this.loading = false;
      if (status === 1) {
        await Swal.fire({ icon: 'success', title: '修改成功' });
        await this.$router.back();
      }
    }
  }

  private setForm(data: any) {
    this.form = data;
    this.isActivityStarted = data.isActivityStarted;
  }

  private async beforeRouteEnter(
    to: Route,
    from: Route,
    next: (to?: (vm: CouponActivityEdit) => void) => void,
  ) {
    const { activityId } = to.params;
    const { data } = await couponActivity.get(activityId);
    data.isActivityStarted = data.startTime && new Date() > new Date(data.startTime);
    data.startTime = moment(data.startTime).format('YYYY-MM-DD HH:mm');
    data.endTime = moment(data.endTime).format('YYYY-MM-DD HH:mm');
    await next(async (vm) => {
      vm.setForm(data);
    });
  }
}
